import { useMemo } from "react";
import { useIntl } from "react-intl";
import * as Yup from "yup";

export const FIELDS = {
  FEE_PERCENT: 'feePercent',
}

export const useValidationSchema = () => {
  const intl = useIntl();

  return useMemo(() => {
    return Yup.object().shape({
      [FIELDS.FEE_PERCENT]: Yup.number().min(1, intl.formatMessage({ id: "organizerEventFeeMinError" })).max(100, intl.formatMessage({ id: "organizerEventFeeMaxError" })).required(intl.formatMessage({ id: "organizerEventFeeRequiredError" }))
    })
  }, [intl])
};